import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import { NavLink } from 'fluxible-router';
import StickyPopover from '../StickyPopover';
import NavigationStore from '../../stores/NavigationStore';
import canUseDOM from '../../util/canUseDOM';
import styles from './styles.module.styl';

// Disable no-danger to allow content to use HTML entities
/* eslint-disable react/no-danger */

const DefinitionTooltip = ({
  dataKey,
  children,
  term
}) => {
  if (!term) {
    return <span dangerouslySetInnerHTML={{ __html: children }} />;
  }

  const { title, definition, short } = term;

  return (
    <StickyPopover
      onMouseEnter={() => { }}
      title={title}
      classOverride={styles.popover}
      popover={
        <div>
          <p dangerouslySetInnerHTML={{ __html: short || definition }} />
          <NavLink href={`/docs/glossary?term=${dataKey}`} className={styles.glossaryLink}>View Glossary</NavLink>
        </div>
      }
    >
      <span className={styles.underlinedWord} dangerouslySetInnerHTML={{ __html: children }} />
    </StickyPopover>
  );
};

DefinitionTooltip.propTypes = {
  dataKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  term: PropTypes.shape({
    title: PropTypes.string,
    definition: PropTypes.string,
    short: PropTypes.string
  })
};

DefinitionTooltip.defaultProps = {
  term: {
    title: '',
    definition: ''
  }
};

DefinitionTooltip.contextTypes = {
  getStore: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired
};

export default connectToStores(
  DefinitionTooltip,
  [NavigationStore],
  (context, { dataKey }) => {
    // Component cannot use NavigationStore until it mounts
    if (!canUseDOM()) return {};

    const glossary = context.getStore(NavigationStore).glossary;
    const term = glossary && dataKey && glossary.termsById[dataKey];

    return { term };
  }
);
